const DOCUMENT = 'SESSIONS_ACTIVE_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_GROUP_REQUEST: DOCUMENT + 'LOAD_GROUP_REQUEST',
  LOAD_GROUP_SUCCESS: DOCUMENT + 'LOAD_GROUP_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadSessionsActive: data => {
    return {
      type: actions.LOAD_REQUEST,
      payload: data,
    };
  },

  loadSessionsActiveSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadGroupSessionsActive: data => ({
    type: actions.LOAD_GROUP_REQUEST,
    payload: data,
  }),

  loadGroupSessionsActiveSuccess: data => ({
    type: actions.LOAD_GROUP_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
